const stepRegistry = {};

function resolve(key) {
  if (!stepRegistry[key]) {
    throw new Error(`Trying to get invalid step with key: ${key}`);
  }
  return stepRegistry[key];
}

function has(key) {
  return Boolean(stepRegistry[key]);
}

function resolveCustomHeader(key) {
  if (!stepRegistry[key] || !stepRegistry[`${key}CustomHeaderComponent`]) {
    return null;
  }
  return stepRegistry[`${key}CustomHeaderComponent`];
}

function resolveCustomHeaderProps(key) {
  if (!stepRegistry[key] || !stepRegistry[`${key}CustomHeaderProps`]) {
    return null;
  }
  return stepRegistry[`${key}CustomHeaderProps`];
}

function register(key, Component, CustomHeaderComponent = null, customHeaderProps = null) {
  stepRegistry[key] = Component;
  if (CustomHeaderComponent !== null) {
    stepRegistry[`${key}CustomHeaderComponent`] = CustomHeaderComponent;
  }
  if (customHeaderProps !== null) {
    stepRegistry[`${key}CustomHeaderProps`] = customHeaderProps;
  }
}

const registry = { resolve, register, resolveCustomHeader, resolveCustomHeaderProps, has };

export default registry;
